import _InfiniteScroll from 'react-infinite-scroll-component';
export const InfiniteScroll = _InfiniteScroll;
//# sourceMappingURL=infinite-scroll-module.js.map